import type { Apartment } from '@/mocks/apartments';

const PLACEHOLDER_IMAGE =
  'https://readdy.ai/api/search-image?query=Modern%20apartment%20building%20exterior%20with%20contemporary%20architecture%2C%20warm%20golden%20daylight%2C%20clean%20residential%20facade%2C%20African%20urban%20real%20estate%2C%20professional%20photography&width=1200&height=800&seq=apt-placeholder-01&orientation=landscape';

interface ApartmentDbRow {
  id: string;
  title: string;
  type?: string | null;
  transaction?: string | null;
  city?: string | null;
  quartier?: string | null;
  price?: number | null;
  bedrooms?: number | null;
  bathrooms?: number | null;
  surface?: number | null;
  description?: string | null;
  images?: string[] | null;
  amenities?: string[] | null;
  available?: boolean | null;
  owner_type?: string | null;
  owner_name?: string | null;
  owner_phone?: string | null;
  featured?: boolean | null;
  created_at?: string | null;
}

export function mapDbApartment(row: ApartmentDbRow): Apartment {
  const images =
    Array.isArray(row.images) && row.images.length > 0 ? row.images : [PLACEHOLDER_IMAGE];
  return {
    id: row.id,
    title: row.title || 'Bien immobilier',
    type: row.type || 'Appartement',
    transaction: row.transaction === 'vente' ? 'vente' : 'location',
    city: row.city || 'Lomé',
    quartier: row.quartier || 'Lomé',
    price: Number(row.price) || 0,
    bedrooms: Number(row.bedrooms) || 0,
    bathrooms: Number(row.bathrooms) || 0,
    surface: Number(row.surface) || 0,
    description: row.description || '',
    images,
    available: Boolean(row.available),
    ownerType: row.owner_type === 'agence' ? 'agence' : 'proprietaire',
    ownerName: row.owner_name || 'Propriétaire',
    ownerPhone: row.owner_phone || '',
    amenities: Array.isArray(row.amenities) ? row.amenities : [],
    postedAt: row.created_at ? row.created_at.slice(0, 10) : new Date().toISOString().slice(0, 10),
    featured: Boolean(row.featured),
  };
}